module.exports = __webpack_public_path__ + "assets/img/commission0.bb53779d.svg";